//@ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { fetchAppReviewDetailsData, updateAppReviewData } from '../../../features/AppReview/AppReviewSlice';
import { ExclamationIcon } from '../../icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import { getColorForLabel } from '../../../utils/colorUtils';
import Badge from '../../common/Badge';
import { fetchReviewDetailsData } from '../../../features/review/reviewSlice';
import { toast } from 'sonner';
import LoadingBar from 'react-top-loading-bar';

// Auto-resizing textarea component
const AutoResizeTextareaCandidate = ({ value, onChange, placeholder }: any) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      // Set initial height to 40px
      textareaRef.current.style.height = "300px";
      // Reset height to auto to get the correct scrollHeight
      textareaRef.current.style.height = "auto";
      // Set the height based on scrollHeight with a minimum of 40px
      textareaRef.current.style.height = `${Math.max(100, textareaRef.current.scrollHeight)}px`;
    }
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      className="resize-none outline-none bg-transparent focus:border-light-gray-200 focus:outline-none focus:!shadow-none focus:ring-transparent
             !ring-0 text-[14px] text-dark-black-100 w-full m-0 placeholder:text-[#9e9ea0] border
       border-solid border-light-gray-200 rounded-md p-2"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={20}
    />
  );
};

function AppReviewDetails({ meetingId, conductReview, setConductReview, currentAppReviewId, job: jobProp, app: appProp, quickData }: any) {
  
  const [meetingData, setMeetingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(meetingData?.comment || '');
  // const { baseId, jobId, applicationId, skillId } = useParams<{ baseId: string; jobId: string; applicationId: string; skillId: string }>();

  const { baseId, jobId: jobIdFromParams, applicationId: applicationIdFromParams, skillId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
    skillId: string
  }>();

  const jobId = jobProp || jobIdFromParams;
  const applicationId = appProp || applicationIdFromParams || quickData

  const dispatch = useAppDispatch();
  const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [scoreCardName, setScoreCardName] = useState(null)
  const navigate = useNavigate();
  const [reviewComment, setReviewComment] = useState(null)
  const [reviewUpdateLoading, setReviewUpdateLoading] = useState(false);

  // Function to find host name by ID
  const getHostName = (hostId :any) => {
    if (!hostId) return { name: "Not specified", profilePic: null };

    const parsedHostId = parseInt(hostId, 10);
    const host = baseMembers.find(member => member.user_id == parsedHostId);

    return host ? { name: host.name, profilePic: host.profile_pic } : { name: `Host ID: ${hostId}`, profilePic: null };
  };

  // Function to format date
  const formatDate = (dateString : any) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  // Function to get status color
  const getStatusColor = (status: any) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  useEffect(() => {
    const fetchMeetingDetails = async () => {
      if (baseId) {
        setLoading(true);
        try {
          const res = await dispatch(
            fetchAppReviewDetailsData({
              baseId: Number(baseId),
              id: meetingId ? meetingId : currentAppReviewId
            })
          ).unwrap();
          if (res.status === 200) {
            setMeetingData(res.data);
          }
        } catch (error) {
          console.error("Error fetching meeting details:", error);
          setError("Failed to load meeting details");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchMeetingDetails();
  }, [baseId, dispatch, meetingId]);


  const handleReviewConduct = () => {
    setConductReview(true);
    navigate(`/${baseId}/job/${jobId}/app/${applicationId}/appreview/${meetingId || currentAppReviewId}/conduct-review`)
  }


  const reviewerDetails = getHostName(meetingData?.review_by);


  useEffect(() => {
    if (meetingData?.comment) {
      setMessage(meetingData.comment);
    }
  }, [meetingData]);


  const handleUpdateAppReview = async () => {
    // Validate message 
    if (!message.trim()) {
      toast.error("Comment cannot be empty");
      return;
    }


    // Prepare payload
    const payload = {
      job_id: jobId,
      app_id: applicationId,
      comment: message,
      status: "done",
    };

    setReviewUpdateLoading(true);

    try {
      // Dispatch update review data thunk
      const response = await dispatch(updateAppReviewData({
        baseId: Number(baseId),
        id: meetingData?.id, // Assuming meeting data has an ID
        payload
      })).unwrap();

      if (response) {
        toast.success("Review updated successfully!");
        // Optionally, you can add any additional logic here like refreshing data
      }
    } catch (error) {
      console.error("Error updating review:", error);
      toast.error(error?.message || "Failed to update review");
    } finally {
      setReviewUpdateLoading(false);
    }
  };


  useEffect(() => {
    if (reviewComment !== null) {
      setMessage(reviewComment);
    }
  }, [reviewComment]);

  const handlePreFill = async () => {
    try {
      const response = await dispatch(fetchReviewDetailsData({
        baseId: Number(baseId),
        userId: meetingData?.review_template_id,
      }));

      // You can check response or handle success/failure here
      if (response?.payload.status === 200) {
        setReviewComment(response?.payload?.data?.review_details);
        // No need to call setMessage here, the useEffect will handle it
      }
    } catch (error) {
      console.error("Error fetching review details:", error);
    }
  };


  if (loading) return <div className="flex items-center justify-center relative z-50" style={{ height: 'calc(100vh - 191px)' }}>
    <div className="simple-spinner-loader">
      <span></span>
    </div>
  </div>

  if (error) return <div className="text-center py-4 text-red-500">Error: {error}</div>;

  if (!meetingData) return <div className='w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3'>
    <ExclamationIcon />
    <p className='text-[#0000007a] text-[13px]'>No results found</p>
  </div>;


  return (
    <div className="max-w-2xl mx-auto bg-white p-0">
      {/* <header className="text-left mb-6 border-b pb-6 flex justify-between items-center">
        <h1 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize">
          App Review Details
        </h1>
        <Badge status={meetingData.status} />
      </header>

      <section className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm font-medium text-gray-500 mb-2">Review By</p>
            <div className="flex items-center mt-1">
              {reviewerDetails.profilePic ? (
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}/${reviewerDetails.profilePic}`}

                  alt={reviewerDetails.name}
                  className="w-8 h-8 rounded-full mr-2"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-gray-200 mr-2 flex items-center justify-center">
                  {reviewerDetails.name.charAt(0)}
                </div>
              )}
              <span className="text-sm">{reviewerDetails.name}</span>
            </div>
          </div>

        



        </div>

        {meetingData.comment && (
          <div>
            <p className="text-sm font-medium text-gray-500 mb-2">Comments</p>
            <div className="bg-gray-50 p-3 rounded-md">
              <p className="text-sm text-gray-700">{meetingData.comment}</p>
            </div>
          </div>
        )}
        {
          !meetingData.created_at && meetingData.updated_at && (
            <div>
              <p className="text-sm font-medium text-gray-500">Created at</p>
              <p className="text-sm mt-1">{formatDate(meetingData.created_at)}</p>
            </div>
          )
        }

        {
          meetingData.created_at && meetingData.updated_at && (

            <div className="table-tooltip before:!bottom-[28px] before:!left-[86px]" data-title={formatDate(meetingData.updated_at)}>
              <p className="text-sm font-medium text-gray-500">Updated at</p>
              <p className="text-sm mt-1">{formatDate(meetingData.updated_at)}</p>
            </div>
          )
        }

        {
          meetingData.status === 'pending' && (
            <button
              onClick={handleReviewConduct}
              className='group inline-flex w-auto items-center px-[14px] py-1 text-[13px] font-medium h-[32px] shrink-0 select-none transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2
             focus-visible:outline-offset-2 disabled:pointer-events-none gap-0  rounded-md text-white outline-primary disabled:opacity-50
             bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600 justify-start [&>span]:flex [&>span]:items-center [&>span]:gap-[6px]'>
              Conduct
            </button>
          )
        }

      </section> */}

      <div className='grid gap-[6px]'>
        <div className='flex items-center justify-between'>
          <label className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5'>
            Candidate review
          </label>
          <label className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5 cursor-pointer'
            onClick={handlePreFill}
          >
            Prefill template
          </label>
        </div>
        <AutoResizeTextareaCandidate
          value={message}
          onChange={(e: any) => setMessage(e.target.value)}
          placeholder="Write a review..."
        />
        <div className='flex items-end justify-end my-5'>
          <button
            onClick={handleUpdateAppReview}
            className='group w-fit inline-flex shrink-0 select-none items-center justify-end px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 transition-colors duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'>

            {reviewUpdateLoading ? (
              <div className='flex items-center gap-[6px]'>
                Update Review
                <div className="simple-spinner">
                  <span></span>
                </div>
              </div>
            ) : (
              'Update Review'
            )}
          </button>
        </div>

      </div>
    </div>
  );
}

export default AppReviewDetails;